/* CIY product-page recommendation rows.

   Shopify only populates `recommendations.products` for requests that come in
   through the recommendation route, so sections/ciy-product-recs.liquid renders
   an empty shell on first paint. This script re-fetches that same section
   through the route and swaps the real markup in, then wires up the carousels
   and the frequently-bought-together totals.

   One fetch feeds all three rows. */
(function () {
  var MONEY = new Intl.NumberFormat('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

  /* Prices arrive from Liquid in the shop's minor unit (paise). Match the
     money_without_trailing_zeros filter used elsewhere: no ".00" on round
     amounts, Indian digit grouping. */
  function money(paise) {
    var rupees = paise / 100;
    var whole = Math.round(rupees * 100) % 100 === 0;
    return '₹' + MONEY.format(whole ? Math.round(rupees) : rupees);
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-ciy-track]');
    var prev = root.querySelector('[data-ciy-prev]');
    var next = root.querySelector('[data-ciy-next]');
    if (!track) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    function behavior() { return reduce.matches ? 'auto' : 'smooth'; }

    function step() {
      var first = track.firstElementChild;
      if (!first) return 300;
      var gap = parseFloat(getComputedStyle(track).columnGap || '24') || 24;
      return first.getBoundingClientRect().width + gap;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      /* Nothing to scroll: hide both arrows rather than show two dead buttons. */
      var scrollable = max > 2;
      /* The track carries 4px of padding so scroll-snap parks the first card at
         scrollLeft == padding, not 0. Without this the "at the start" test never
         matches and the prev arrow stays lit on a freshly loaded row. */
      var atStart = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      root.classList.toggle('is-static', !scrollable);
      if (prev) prev.disabled = !scrollable || track.scrollLeft <= atStart + 2;
      if (next) next.disabled = !scrollable || track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: behavior() }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: behavior() }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function initFbt(form) {
    var checks = Array.prototype.slice.call(form.querySelectorAll('[data-ciy-fbt-check]'));
    var totalEl = form.querySelector('[data-ciy-fbt-total]');
    var addBtn = form.querySelector('[data-ciy-fbt-add]');
    if (!checks.length || !addBtn) return;

    function update() {
      var total = 0;
      var picked = 0;

      checks.forEach(function (check) {
        var tile = check.closest('[data-ciy-fbt-tile]');
        var on = check.checked && !check.disabled;
        if (tile) tile.classList.toggle('is-off', !on);

        /* Disabled inputs are not submitted, which is how an unchecked tile is
           kept out of the cart without rebuilding the form. */
        var lines = form.querySelectorAll('[name^="items[' + lineIndex(check) + ']"]');
        Array.prototype.forEach.call(lines, function (input) { input.disabled = !on; });

        if (on) {
          picked += 1;
          total += parseInt(check.dataset.price, 10) || 0;
        }
      });

      if (totalEl) totalEl.textContent = money(total);
      addBtn.disabled = picked === 0;
      addBtn.textContent = picked === 0
        ? 'Select an item'
        : (picked === checks.length ? 'Add all ' + picked + ' to Cart' : 'Add ' + picked + ' to Cart');
    }

    function lineIndex(check) {
      /* data-line is "ciy-fbt-line-N"; the hidden inputs are items[N][...]. */
      var m = /(\d+)$/.exec(check.dataset.line || '');
      return m ? m[1] : '';
    }

    checks.forEach(function (c) { c.addEventListener('change', update); });
    update();
  }

  function wire(root) {
    root.querySelectorAll('[data-ciy-carousel]').forEach(initCarousel);
    root.querySelectorAll('[data-ciy-fbt]').forEach(initFbt);
  }

  function load(shell) {
    var url = shell.dataset.url;
    if (!url || shell.dataset.loaded === '1') return;
    shell.dataset.loaded = '1';

    fetch(url)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('HTTP ' + r.status)); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-ciy-recs]');
        /* No recommendations for this product: leave the shell empty so the page
           simply ends after the collection row. */
        if (!fresh || !fresh.firstElementChild) return;
        shell.innerHTML = fresh.innerHTML;
        wire(shell);
      })
      .catch(function () { /* leave the shell empty — nothing renders, nothing breaks */ });
  }

  function boot() {
    document.querySelectorAll('[data-ciy-recs]').forEach(function (shell) {
      if (shell.firstElementChild) { wire(shell); } else { load(shell); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
